import { getE2EUserProfileById } from "../services/E2EAPI";

const normalizeIds = (userIds) => {
  if (!Array.isArray(userIds)) return [];

  return [...new Set(userIds.filter(Boolean).map((id) => String(id).trim()).filter(Boolean))];
};

const fallbackUserDisplayName = (userId) => {
  if (!userId) return "—";

  const value = String(userId);
  const atIndex = value.indexOf("@");
  if (atIndex > 0) return value.slice(0, atIndex);

  const pipeIndex = value.lastIndexOf("|");
  if (pipeIndex > -1 && pipeIndex < value.length - 1) return value.slice(pipeIndex + 1);

  const slashIndex = Math.max(value.lastIndexOf("/"), value.lastIndexOf("\\"));
  if (slashIndex > -1 && slashIndex < value.length - 1) return value.slice(slashIndex + 1);

  const colonIndex = value.lastIndexOf(":");
  if (colonIndex > -1 && colonIndex < value.length - 1) return value.slice(colonIndex + 1);

  return value;
};

export const fetchE2EUserProfilesByIds = async (userIds) => {
  const ids = normalizeIds(userIds);
  if (ids.length === 0) {
    return {};
  }

  const results = await Promise.allSettled(
    ids.map((userId) => getE2EUserProfileById(userId))
  );

  return results.reduce((acc, result, index) => {
    if (result.status === "fulfilled" && result.value) {
      acc[ids[index]] = result.value;
    }
    return acc;
  }, {});
};

export const resolveE2EUserDisplayName = (userId, userProfilesById = {}) => {
  if (!userId) return "—";

  const value = String(userId);
  const profile = userProfilesById[value];

  if (profile?.name) return profile.name;
  if (profile?.email) return profile.email;

  return fallbackUserDisplayName(value);
};

export const getE2EUserProfileDetails = (userId, userProfilesById = {}) => {
  if (!userId) {
    return null;
  }

  const value = String(userId);
  const profile = userProfilesById[value];
  if (!profile) {
    return null;
  }

  return {
    userId: profile.userId || value,
    name: profile.name || null,
    email: profile.email || null,
    organizationName: profile.organizationName || profile.organizationId || null,
  };
};

export const resolveE2EUserDisplayNameWithOrg = (userId, userProfilesById = {}) => {
  if (!userId) return "—";

  const displayName = resolveE2EUserDisplayName(userId, userProfilesById);
  const details = getE2EUserProfileDetails(userId, userProfilesById);
  
  if (details?.organizationName) {
    return `${displayName} (${details.organizationName})`;
  }
  
  return displayName;
};
